
import { Dispatch, SetStateAction } from 'react';
import { KaziModal } from '../Kazi/KaziModal';
import { Button, Typography } from '@mui/material';
import { useAppDispatch } from '../../Redux/store';
import { useNavigate } from 'react-router-dom';
import { setJobPostingModalOpen } from '../../Redux/slices/JobPostingCreationSlice';

interface UpgradeSubscriptionModalProps {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
}
export const UpgradeSubscriptionModal = ({open, setOpen}:UpgradeSubscriptionModalProps ) => {
    /* ******************** Hooks ******************** */
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    const handleClose = () => {
        setOpen(false)
    }
    const handleUpgrade = () => {
        handleClose();
        navigate('/settings/membership?mode=edit')
    }
    const handleCancel = () => {
        handleClose();
        navigate('/post-creation');
        // dispatch(setJobPostingModalOpen(true)); 
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
    <KaziModal
        open={open}
        handleClose={handleClose}
        title='Upgrade to post this type of job'
        content={<Typography variant='body-medium'>You’ll need to upgrade to Premium to post a full-time job or an internship.</Typography>}
        actions={[
            <Button variant='outlined' onClick={handleCancel}>Cancel</Button>,
            <Button variant='contained' onClick={handleUpgrade}>Upgrade</Button>
        ]}
    />
    )
}